require("core-js/features/promise");
//import { ShowReadingEntryLink } from "../../../Areas/eServices/Scripts/Default/ShowReadingEntryLink";
import { DefaultLoaderFactory } from "../../inpulse/Loaders/DefaultLoaderFactory";
import { DefaultValidationNotificator } from "../../inpulse/Notificators/IValidationNotificator";
//declare var readingEntryApiUrl: string;
declare var window: any;
window._lf = new DefaultLoaderFactory();
window._notificator = new DefaultValidationNotificator();
$(function () {
    //window.permissionModule = new ShowReadingEntryLink(readingEntryApiUrl, true);
    // window.permissionModule.Init();

});